import { createContext } from 'react';

export const HealthContext = createContext({});

export const HealthProvider = HealthContext.Provider;
